import { render, staticRenderFns } from "./WarehousesList.vue?vue&type=template&id=83ce00e2&"
import script from "./WarehousesList.vue?vue&type=script&lang=js&"
export * from "./WarehousesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports